import { callAPI } from "../../network/networkConnection";

const BASE_URL = process.env.REACT_APP_APIUrl + "cross-border-order";

// Get all cross-border orders with filters
const getAllCrossBorderOrders = (queryParams = "") => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}${queryParams}`, "GET", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Get single order by ID
const getCrossBorderOrderById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/${id}`, "GET", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Create cross-border orders (sequential processing)
const createCrossBorderOrders = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/create`, "POST", { "Content-Type": "application/json" }, JSON.stringify(payload))
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Preview order grouping before creation
const previewOrderGrouping = (payload) => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/preview`, "POST", { "Content-Type": "application/json" }, JSON.stringify(payload))
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Fetch/Refresh order details from 1688 API
const fetchOrderDetails = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/${id}/fetch-details`, "POST", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Fetch logistics info for a cross-border order
const fetchLogisticsInfo = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/${id}/logistics-info`, "POST", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Fetch logistics trace for a cross-border order
const fetchLogisticsTrace = (id, logisticsId = null) => {
  const payload = logisticsId ? { logisticsId } : {};
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/${id}/logistics-trace`, "POST", { "Content-Type": "application/json" }, JSON.stringify(payload))
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Bulk fetch logistics info for multiple orders
const bulkFetchLogisticsInfo = (orderIds) => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/bulk-logistics-info`, "POST", { "Content-Type": "application/json" }, JSON.stringify({ orderIds }))
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Get orders grouped by supplier for cross-border creation
const getOrdersGroupedBySupplier = () => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/grouped-by-supplier`, "GET", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

// Get placed order IDs (processing status with alibaba IDs)
const getPlacedOrderIds = () => {
  return new Promise((resolve, reject) => {
    callAPI(`${BASE_URL}/placed-order-ids`, "GET", { "Content-Type": "application/json" })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const crossBorderOrderService = {
  getAllCrossBorderOrders,
  getCrossBorderOrderById,
  createCrossBorderOrders,
  previewOrderGrouping,
  fetchOrderDetails,
  fetchLogisticsInfo,
  fetchLogisticsTrace,
  bulkFetchLogisticsInfo,
  getOrdersGroupedBySupplier,
  getPlacedOrderIds,
};
